package com.tixforgigs.common.core.extensions

import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.util.AuthUtil.isUserLoggedIn
import com.tixforgigs.common.core.util.StorageUtil
import com.tixforgigs.common.core.util.StorageUtil.setLocalStorageItem
import io.kvision.core.Widget
import io.kvision.navigo.NavigateOptions
import io.kvision.panel.Root
import io.kvision.routing.Routing
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.serialization.builtins.serializer

fun Routing.navigateTo(
  view: View,
  queryParameter: Map<String, String> = emptyMap(),
  options: NavigateOptions? = null,
) {
  when (view) {
    is View.LOGIN -> {
      setLocalStorageItem(
        key = StorageUtil.StorageKey.LoginStartLocation,
        item = window.location.pathname,
        serializer = String.serializer()
      )
    }

    else -> Unit
  }
  options?.let { options ->
    navigate(
      to = view.path.plus(queryParameter.toQueryString()),
      options = options
    )
  } ?: run {
    navigate(to = view.path.plus(queryParameter.toQueryString()))
  }
}

fun Routing.navigateIfAuthorizedTo(
  view: View,
  queryParameter: Map<String, String> = emptyMap(),
  options: NavigateOptions? = null,
) {
  if (isUserLoggedIn.value) {
    options?.let { options ->
      navigate(
        to = view.path.plus(queryParameter.toQueryString()),
        options = options
      )
    } ?: run {
      navigate(to = view.path.plus(queryParameter.toQueryString()))
    }
  } else navigateTo(view = View.LOGIN)
}

fun Map<String, String>.toQueryString(): String {
  return if (isNotEmpty()) {
    toList().joinToString(prefix = "?", separator = "&") { "${it.first}=${it.second}" }
  } else String()
}

object RoutingUtil {

  lateinit var routing: Routing
  lateinit var appRoot: Root
  var currentView: Widget? = null
  const val APP_VIEW_ID = "app"

  /** offizielle Coroutines-Doku empfiehlt Main/Structured Concurrency.*/
  val AppScope = CoroutineScope(
    SupervisorJob() + Dispatchers.Main.immediate + CoroutineExceptionHandler { _, e ->
      console.error("Uncaught in appScope:", e)
    }
  )

  fun mount(view: Widget) = with(appRoot) {
    removeAll()
    currentView?.dispose()
    currentView = view.apply { useSnabbdomDistinctKey() }.also {
      add(it)
    }
  }

  fun mountIfAuthorized(view: Widget) {
    if (isUserLoggedIn.value) {
      mount(view)
    } else routing.navigateTo(View.LOGIN)
  }
}
